import React from "react";
import ProfileTextCard from "./ProfileTextCard";

/**
 * 自己実績・自己PR セクション
 *
 * - FrameCard ベースのテキスト表示
 * - 長文プロフィール情報をまとめて表示
 */
const ProfileTextSection = ({ profile }) => {
  return (
    <>
      <ProfileTextCard title="自己PR" text={profile.self_promotion} />
      <ProfileTextCard title="自己実績" text={profile.achievement} />
    </>
  );
};

export default ProfileTextSection;
